import { useState, useEffect } from 'react';
import Sidebar from './Sidebar';
import TopBar from './TopBar';
import CommandPalette from './CommandPalette';
import BottomTabBar from './BottomTabBar';
import ScrollToTop from './ScrollToTop';

const COLLAPSED_KEY = 'bm-sidebar-collapsed';

export default function AppLayout({ children }) {
  const [collapsed, setCollapsed] = useState(() => {
    return localStorage.getItem(COLLAPSED_KEY) === 'true';
  });
  const [paletteOpen, setPaletteOpen] = useState(false);

  // Auto-collapse on small screens
  useEffect(() => {
    const mq = window.matchMedia('(max-width: 768px)');
    const handler = (e) => {
      if (e.matches) setCollapsed(true);
    };
    handler(mq);
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, []);

  const toggleCollapsed = () => {
    setCollapsed(c => {
      const next = !c;
      localStorage.setItem(COLLAPSED_KEY, String(next));
      return next;
    });
  };

  // Global Cmd+K
  useEffect(() => {
    const handler = (e) => {
      if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
        e.preventDefault();
        setPaletteOpen(o => !o);
      }
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, []);

  const sidebarWidth = collapsed ? 'md:pl-16' : 'md:pl-60';

  return (
    <div className="h-screen overflow-hidden bg-stone-50 dark:bg-stone-950">
      <Sidebar collapsed={collapsed} onToggle={toggleCollapsed} />

      <TopBar
        collapsed={collapsed}
        onSearchOpen={() => setPaletteOpen(true)}
      />

      {/* Page content — fixed shell between TopBar and BottomTabBar.
          main is the ONLY scroll container so sticky headers work on iOS. */}
      <main
        className={`
          ${sidebarWidth}
          fixed top-14 left-0 right-0 bottom-0
          overflow-y-auto overscroll-none
          pb-16 md:pb-0
          transition-all duration-200
          bg-stone-50 dark:bg-stone-950
        `}
        id="app-main-scroll"
      >
        {children}
      </main>

      <CommandPalette
        open={paletteOpen}
        onClose={() => setPaletteOpen(false)}
      />
      <BottomTabBar />
      <ScrollToTop />
    </div>
  );
}
